import styled from 'styled-components';

export const HomeListEvents = styled.div.attrs({
    className: 'home-list-events',
})`
    margin-top: 3rem;
`;
